import React from 'react';
import { Label, Icon, Popup } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const TypeButton = ({ label, icon, showText, showIcon, size, onlyContent }) => {
  const labelContent = (
    <>
      {showIcon && (
        <Icon
          name={icon}
          style={{ marginRight: !showText ? 'unset' : '1em' }}
        />
      )}
      {showText && label}
    </>
  );

  return (
    <>
      {onlyContent ? (
        labelContent
      ) : (
        <Popup
          basic
          position="top left"
          content={label}
          disabled={showText}
          trigger={
            <Label
              as="b"
              className="inspectionType"
              size={size}
              content={labelContent}
            />
          }
        />
      )}
    </>
  );
};

TypeButton.propTypes = {
  label: PropTypes.string,
  icon: PropTypes.string,
  showText: PropTypes.bool,
  showIcon: PropTypes.bool,
  onlyContent: PropTypes.bool,
  size: PropTypes.string
};

TypeButton.defaultProps = {
  label: 'Default Label',
  icon: '',
  showText: true,
  showIcon: true,
  onlyContent: false,
  size: 'medium'
};

export default TypeButton;
